import React from "react";
import { connect } from "react-redux";
import Request from "../../request";
import {
    FaUsers,
    FaUser,
    FaClock,
    FaHourglassHalf,
    FaCheck,
    FaTimes,
    FaPhone,
    FaPhoneSlash,
    FaExclamationTriangle,
    FaQuestionCircle,
    FaBriefcase,
    FaHandshake,
    FaCalendar,
    FaCalendarAlt,
    FaHistory,
    FaBook,
    FaGlobe,
    FaFacebookSquare,
    FaGoogle,
    FaInstagram,
    FaNewspaper,
    FaWhatsapp,
    FaUserClock,
    FaCalendarDay,
    FaCalendarTimes,
    FaUserCheck,
    FaFire,
    FaSmile,
    FaSnowflake,
    FaUserTimes,
    FaClipboardCheck,
    FaBolt,
    FaLightbulb,
    FaRegSnowflake,
    FaUserSlash,
    FaClipboardList,
    FaPassport,
    FaTasks,
    FaCalendarPlus,
    FaRegCalendarAlt
} from "react-icons/fa";
import { Col, Row, Card, Button, Icon } from "antd";
import ListDrawer from './list';
import './css/frontOfficeDashboard.css';
import _ from 'lodash';


const followUpStatusMeta = {
    "Not Interested": { icon: <FaTimes />, color: "bg-red" },
    "Didn't Pick up Call": { icon: <FaPhoneSlash />, color: "bg-orange" },
    "Number out of service": { icon: <FaExclamationTriangle />, color: "bg-dark-red" },
    "Dead": { icon: <FaTimes />, color: "bg-dark-red" },
    "Active": { icon: <FaUser />, color: "bg-blue" },
    "Busy, Call Later": { icon: <FaClock />, color: "bg-yellow" },
    "Number not connected": { icon: <FaPhoneSlash />, color: "bg-grey" },
    "Out Of town": { icon: <FaCalendarAlt />, color: "bg-orange" },
    "Cold": { icon: <FaUserClock />, color: "bg-grey" },
    "Untouched": { icon: <FaQuestionCircle />, color: "bg-grey" },
    "Job": { icon: <FaBriefcase />, color: "bg-blue" },
    "OBD Call - Not interested": { icon: <FaTimes />, color: "bg-red" },
    "Another query": { icon: <FaHandshake />, color: "bg-blue" },
    "Commission Done": { icon: <FaCheck />, color: "bg-green" },
    "Spouse Visa": { icon: <FaUsers />, color: "bg-blue" },
    "OBD Call - Interested": { icon: <FaCheck />, color: "bg-green" },
    "Final Decision Pending": { icon: <FaHourglassHalf />, color: "bg-yellow" },
    "B2B": { icon: <FaHandshake />, color: "bg-amber" }
};



const bucketStatusMeta = {
    "0-3 Days": { icon: <FaClock />, color: "bg-red" },
    "4-7 Days": { icon: <FaCalendar />, color: "bg-orange" },
    "8-15 Days": { icon: <FaCalendarAlt />, color: "bg-blue" },
    "15+ Days": { icon: <FaHistory />, color: "bg-grey" }
};




const sourceMeta = {
    "Not Selected": { icon: <FaQuestionCircle />, color: "bg-grey" },
    "Facebook": { icon: <FaFacebookSquare />, color: "bg-blue" },
    "Google": { icon: <FaGoogle />, color: "bg-red" },
    "Instagram": { icon: <FaInstagram />, color: "bg-pink" },
    "Whatsapp": { icon: <FaWhatsapp />, color: "bg-green" },
    "Website": { icon: <FaGlobe />, color: "bg-green" },
    "Newspaper": { icon: <FaNewspaper />, color: "bg-grey" },
    "Education Fair": { icon: <FaBook />, color: "bg-blue" },
    "Seminar": { icon: <FaUser />, color: "bg-blue" },
    "Walk-In": { icon: <FaUser />, color: "bg-blue" },
    "Telephone": { icon: <FaPhone />, color: "bg-orange" },
    "Online": { icon: <FaGlobe />, color: "bg-green" }
};

const leadQualityMeta = {
    // Qualified Leads
    "Qualified + Registered": { icon: <FaUserCheck />, color: "bg-blue" },
    "Qualified + Hot": { icon: <FaFire />, color: "bg-red" },
    "Qualified + Warm": { icon: <FaSmile />, color: "bg-orange" },
    "Qualified + Cold": { icon: <FaSnowflake />, color: "bg-cyan" },
    "Qualified + Lost": { icon: <FaUserTimes />, color: "bg-grey" },

    // Potential Leads
    "Potential + Registered": { icon: <FaClipboardCheck />, color: "bg-green" },
    "Potential + Hot": { icon: <FaBolt />, color: "bg-red" },
    "Potential + Warm": { icon: <FaLightbulb />, color: "bg-orange" },
    "Potential + Cold": { icon: <FaRegSnowflake />, color: "bg-cyan" },
    "Potential + Lost": { icon: <FaUserSlash />, color: "bg-grey" }
};




class CounsellorDashboard extends React.Component {
    state = {
        applications: {
            total: 0,
            arr: []
        },
        conversionRatio: {
            counsellings: 0,
            registrations: 0,
            ratio: "0%"
        },
        followupsCount: {
            "Not Interested": { total: 0, arr: [] },
            "Didn't Pick up Call": { total: 0, arr: [] },
            "Number out of service": { total: 0, arr: [] },
            "Dead": { total: 0, arr: [] },
            "Active": { total: 0, arr: [] },
            "Busy, Call Later": { total: 0, arr: [] },
            "Number not connected": { total: 0, arr: [] },
            "Out Of town": { total: 0, arr: [] },
            "Cold": { total: 0, arr: [] },
            "Untouched": { total: 0, arr: [] },
            "Job": { total: 0, arr: [] },
            "OBD Call - Not interested": { total: 0, arr: [] },
            "Another query": { total: 0, arr: [] },
            "Commission Done": { total: 0, arr: [] },
            "Spouse Visa": { total: 0, arr: [] },
            "OBD Call - Interested": { total: 0, arr: [] },
            "Final Decision Pending": { total: 0, arr: [] },
            "B2B": { total: 0, arr: [] },
        },
        newCounsellings: {
            "Today": { total: 0, arr: [] },
            "This Week": { total: 0, arr: [] },
            "This Month": { total: 0, arr: [] },
        },
        activities: {
            "Today": { total: 0, arr: [] },
            "This Week": { total: 0, arr: [] },
            "This Month": { total: 0, arr: [] },
        },
        qualityRatings: {
            "Qualified": { total: 0, arr: [] },
            "Potential": { total: 0, arr: [] },
            "Unqualified": { total: 0, arr: [] },
        },
        ratings: {
            "Hot": { total: 0, arr: [] },
            "Warm": { total: 0, arr: [] },
            "Cold": { total: 0, arr: [] }
        },
        bucketResult: {
            "0-3 Days": { total: 0, arr: [] },
            "4-7 Days": { total: 0, arr: [] },
            "8-15 Days": { total: 0, arr: [] },
            "15+ Days": { total: 0, arr: [] }
        },
        todayFollowup: {
            total: 0,
            arr: []
        },
        missedFollowup: {
            total: 0,
            arr: []
        },
        newRegistrations: {
            "Today": { total: 0, arr: [] },
            "Week": { total: 0, arr: [] },
            "Month": { total: 0, arr: [] },
            "Quarter": { total: 0, arr: [] },
            "Half Year": { total: 0, arr: [] },
            "Year": { total: 0, arr: [] }
        },
        targetVsRegistration: {
            "Today": 0,
            "Week": 0,
            "Month": 0,
            "Quarter": 0,
            "Half Year": 0,
            "Year": 0
        },

        untouchedLeads: {
            total: 0,
            arr: []
        },
        visaApplied: {
            total: 0,
            arr: []
        },
        visaApproved: {
            total: 0,
            arr: []
        },
        visaFillings: {
            total: 0,
            arr: []
        },
        assignedLeads: {
            total: 0,
            arr: []
        },
        drawer: false,
        drawerParam: {},
        sourceLeads: {},
        sourceConverted: {},
        qualityLeadsData: {},
        registeredLeadsData: {},
        untouchedQualified: {},
        untouchedHot: {},
        untouchedPotential: {},
        pendingApplications: {},
        pendingVisaApplications: {},
        pendingConsultancy: {},
    };

    mergeStatus(defaultObj, apiObj = {}) {
        let result = { ...defaultObj };

        Object.keys(apiObj).forEach(key => {
            if (result[key]) {
                result[key] = {
                    ...result[key],
                    ...apiObj[key]
                };
            }
        });

        return result;
    }




    loadAllApis = async (params = {}) => {

        let response = await Request.loadCounsellorDashboardData();

        this.setState({
            ...response,
            newCounsellings: this.mergeStatus(this.state.newCounsellings, response.newCounsellings),
            newRegistrations: this.mergeStatus(this.state.newRegistrations, response.newRegistrations),
            followupsCount: this.mergeStatus(this.state.followupsCount, response.followupsCount),
        });
    };



    componentDidMount() {
        this.loadAllApis();
    }
    render() {
        let { untouchedLeads, untouchedQualified, untouchedHot, untouchedPotential, pendingApplications, pendingVisaApplications, pendingConsultancy, sourceLeads, sourceConverted, todayFollowup, missedFollowup, drawer, bucketResult, drawerParam, assignedLeads, followupsCount } = this.state;
        return (
            <div>
                <div className="fod-container">
                    <h4 className="fod-heading">Sales Counsellor</h4>
                    {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                    <div className="section-tag">Lead Overview</div>
                    <Row className="fod-row">
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-blue">
                                    <FaUsers />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Total Leads Assigned</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Total Leads Assigned", arr: assignedLeads.arr, count: assignedLeads.total, bgColorClass: "bg-blue", icon: <FaUsers /> }
                                        })}>{assignedLeads.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {/* <Col span={6}>
                <div className="info-box glass">
                <span className="info-box-icon bg-color-blue elevation-1"><FaUsers /></span>
                <div className="info-box-content">
                <span className="info-box-text">Total Leads Assigned</span>
                <span className="info-box-number">
                <a onClick={() => this.setState({
                drawer: true,
                drawerParam: { title: "Total Leads Assigned", arr: assignedLeads.arr, count: assignedLeads.total }
                })}>{assignedLeads.total}</a>
                </span>
                </div>
                </div>
                </Col> */}
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-amber">
                                    <FaHourglassHalf />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Untouched Leads</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Untouched Leads", arr: untouchedLeads.arr, count: untouchedLeads.total, bgColorClass: "bg-amber", icon: <FaHourglassHalf /> }
                                        })}>{untouchedLeads.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {/* <Col span={6}>
                    <div className="info-box glass">
                    <span className="info-box-icon bg-color-blue elevation-1"><FaHourglassHalf /></span>
                    <div className="info-box-content">
                    <span className="info-box-text">Untouched Leads</span>
                    <span className="info-box-number">
                    <a onClick={() => this.setState({
                    drawer: true,
                    drawerParam: { title: "Untouched Leads", arr: untouchedLeads.arr, count: untouchedLeads.total }
                    })}>{untouchedLeads.total}</a>
                    </span>
                    </div>
                    </div>
                    </Col> */}
                    </Row>
                    <Row gutter={[20, 20]} className="fod-row modern-stats-grid">
                        {[
                            { title: "New Leads", data: this.state.newCounsellings, color: "#3b82f6" },
                            { title: "Quality Rating", data: this.state.qualityRatings, color: "#f59e0b" },
                            { title: "Conversion Rating", data: this.state.ratings, color: "#10b981" },
                            { title: "Activities", data: this.state.activities, color: "#6366f1" }
                        ].map((section, idx) => {
                            // Calculate the maximum value in this specific section for the progress bars
                            const sectionValues = Object.values(section.data || {}).map(i => i.total || 0);
                            const maxVal = sectionValues.length > 0 ? Math.max(...sectionValues) : 0;

                            return (
                                <Col span={6} key={idx}>
                                    <Card
                                        className="modern-list-card"
                                        title={
                                            <div className="card-header-flex">
                                                <span className="header-dot" style={{ backgroundColor: section.color }}></span>
                                                {section.title}
                                            </div>
                                        }
                                    >
                                        <div className="card-list-container">
                                            {Object.keys(section.data || {}).map((key) => {
                                                const item = section.data[key];
                                                const percentage = maxVal > 0 ? (item.total / maxVal) * 100 : 0;

                                                return (
                                                    <div className="list-item-row" key={key}>

                                                        <span className="label-text" title={key}>{key}</span>
                                                        <div
                                                            className="count-badge"
                                                            onClick={() => this.setState({
                                                                drawer: true,
                                                                drawerParam: {
                                                                    title: `${key} ${section.title}`,
                                                                    arr: item.arr,
                                                                    count: item.total,
                                                                    bgColorClass: "bg-blue"
                                                                }
                                                            })}
                                                        >
                                                            {item.total}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                    <Card
                        title={
                            <div className="card-header-flex">
                                Lead Ageing Brackets
                            </div>
                        }
                        style={{ marginTop: 20 }}
                        className="modern-list-card ageing-card"
                    >
                        <Row className="fod-row" gutter={[24, 0]}>
                            {Object.keys(bucketResult).map((key, index) => {
                                const item = bucketResult[key];
                                const meta = bucketStatusMeta[key] || {};
                                const isLast = index === Object.keys(bucketResult).length - 1;

                                return (
                                    <Col span={6} key={key}>
                                        <div className="stat-card">
                                            <div className={`stat-icon-wrapper ${meta.color || 'bg-blue'}`}>
                                                {meta.icon}
                                            </div>
                                            <div className="stat-data">
                                                <div className="stat-label">{key}</div>
                                                <div className="stat-value">
                                                    <a onClick={() => this.setState({
                                                        drawer: true,
                                                        drawerParam: { title: key, arr: item.arr, count: item.total, bgColorClass: `${meta.color || 'bg-blue'}`, icon: meta.icon }
                                                    })}>{untouchedLeads.total}</a>
                                                </div>
                                            </div>

                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Card>
                    {Object.keys(this.state.qualityLeadsData || {}).length > 0 && (
                        <Card
                            title={
                                <div className="card-header-flex">
                                    Quality Rating + Conversion Rating
                                </div>
                            }
                            style={{ marginTop: 20 }}
                            className="modern-list-card"
                        >
                            <Row className="fod-row" gutter={[24, 0]}>
                                {Object.keys(this.state.qualityLeadsData).map((key, index) => {
                                    const item = this.state.qualityLeadsData[key];
                                    const meta = leadQualityMeta[key];

                                    return (
                                        <Col span={6} key={key}>
                                            <div className="stat-card">
                                                <div className={`stat-icon-wrapper ${meta.color || 'bg-blue'}`}>
                                                    {meta.icon}
                                                </div>
                                                <div className="stat-data">
                                                    <div className="stat-label">{key}</div>
                                                    <div className="stat-value">
                                                        <a onClick={() => this.setState({
                                                            drawer: true,
                                                            drawerParam: {
                                                                title: key, arr: item.arr,
                                                                count: (key === "Qualified + Registered" ||
                                                                    key === "Potential + Registered")
                                                                    ? item.total + "%"
                                                                    : item.total,
                                                                bgColorClass: `${meta.color || 'bg-blue'}`, icon: meta.icon
                                                            }
                                                        })}>{
                                                                (key === "Qualified + Registered" ||
                                                                    key === "Potential + Registered")
                                                                    ? item.total + "%"
                                                                    : item.total
                                                            }</a>
                                                    </div>
                                                </div>

                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Card>
                    )}
                    {/* <Card title="Quality Rating + Conversion Rating" style={{ marginTop: 10 }}>
                        <Row className="fod-row">

                            {Object.keys(this.state.qualityLeadsData).map((key) => {
                                const item = this.state.qualityLeadsData[key];
                                const meta = leadQualityMeta[key];

                                return (
                                    <Col span={6} key={key}>
                                        <div className="info-box glass">

                                            <span className={`info-box-icon ${meta.color} elevation-1`}>
                                                {meta.icon}
                                            </span>

                                            <div className="info-box-content">
                                                <span className="info-box-text" title={key}>
                                                    {key}
                                                </span>

                                                <span className="info-box-number">
                                                    <a
                                                        onClick={() =>
                                                            this.setState({
                                                                drawer: true,
                                                                drawerParam: {
                                                                    title: key,
                                                                    arr: item.arr,
                                                                    count: (key === "Qualified + Registered" ||
                                                                        key === "Potential + Registered")
                                                                        ? item.total + "%"
                                                                        : item.total
                                                                }
                                                            })
                                                        }
                                                    >
                                                        {
                                                            (key === "Qualified + Registered" ||
                                                                key === "Potential + Registered")
                                                                ? item.total + "%"
                                                                : item.total
                                                        }
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}

                        </Row>
                    </Card> */}

                    {/* Followups start */}
                    <div className="section-tag">Follow Ups</div>
                    <Row className="fod-row">
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-indigo">
                                    <FaCalendarDay />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Today's Followup</div>
                                    <div className="stat-value">
                                        <span className="info-box-number">
                                            <a onClick={() => this.setState({
                                                drawer: true,
                                                drawerParam: { title: "Today Followup", arr: todayFollowup.arr, count: todayFollowup.total, bgColorClass: "bg-indigo", icon: <FaCalendarDay /> }
                                            })}>{todayFollowup.total}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-red-soft">
                                    <FaCalendarTimes />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Missed Followup</div>
                                    <div className="stat-value">
                                        <span className="info-box-number">
                                            <a onClick={() => this.setState({
                                                drawer: true,
                                                drawerParam: { title: "Missed Followup", arr: missedFollowup.arr, count: missedFollowup.total, bgColorClass: "bg-red-soft", icon: <FaCalendarTimes /> }
                                            })}>{missedFollowup.total}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {Object.keys(this.state.followupsCount || {}).length > 0 && (
                        <Card
                            title={
                                <div className="card-header-flex">
                                    Follow Up Tags Summary
                                </div>
                            }
                            style={{ marginTop: 20 }}
                            className="modern-list-card"
                        >
                            <Row className="fod-row" gutter={[24, 0]}>
                                {
                                    Object.keys(followupsCount)
                                        .filter((key) => followupsCount[key].total > 0)
                                        .map((key) => {

                                            const item = followupsCount[key];
                                            const meta = followUpStatusMeta[key] || {};

                                            return (
                                                <Col span={6} key={key}>
                                                    <div className="stat-card">
                                                        <div className={`stat-icon-wrapper ${meta.color || 'bg-blue'}`}>
                                                            {meta.icon}
                                                        </div>
                                                        <div className="stat-data">
                                                            <div className="stat-label">{key}</div>
                                                            <div className="stat-value">
                                                                <a onClick={() =>
                                                                    this.setState({
                                                                        drawer: true,
                                                                        drawerParam: {
                                                                            title: key,
                                                                            arr: item.arr,
                                                                            count: item.total,
                                                                            bgColorClass: `${meta.color || 'bg-blue'}`,
                                                                            icon: meta.icon
                                                                        }
                                                                    })
                                                                }
                                                                >{item.total}</a>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                            );
                                        })
                                }
                            </Row>
                        </Card>


                    )}
                    {/* <Card title="Follow Up Tags Summary" style={{ marginTop: 10 }}>
                        <Row className="fod-row">

                            {
                                Object.keys(followupsCount)
                                    .filter((key) => followupsCount[key].total > 0)
                                    .map((key) => {

                                        const item = followupsCount[key];
                                        const meta = followUpStatusMeta[key] || {};

                                        return (
                                            <Col span={6} key={key}>
                                                <div className="info-box glass">

                                                    <span className={`info-box-icon ${meta.color} elevation-1`}>
                                                        {meta.icon}
                                                    </span>

                                                    <div className="info-box-content">
                                                        <span className="info-box-text" title={key}>
                                                            {key}
                                                        </span>

                                                        <span className="info-box-number">
                                                            <a
                                                                onClick={() =>
                                                                    this.setState({
                                                                        drawer: true,
                                                                        drawerParam: {
                                                                            title: key,
                                                                            arr: item.arr,
                                                                            count: item.total
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {item.total}
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })
                            }


                        </Row>
                    </Card> */}
                    {/* Followup Calender */}
                    {/* <Card style={{ marginTop: 10 }}>
                                            <Row>
                                            <CalenderFollowUp />
                                            </Row>
                                            </Card> */}

                    {/* Lead Source Insight Start */}
                    {
                        // Section title
                        (Object.keys(sourceLeads).length > 0 || Object.keys(sourceConverted).length > 0) && (
                            <div className="section-tag">Lead Source Insights</div>
                        )
                    }

                    {
                        // Leads By Source
                        Object.keys(sourceLeads)
                            .filter(key => sourceLeads[key].total > 0) // only show if total > 0
                            .length > 0 && (
                            <Card
                                title={
                                    <div className="card-header-flex">
                                        Leads By Source
                                    </div>
                                }
                                style={{ marginTop: 20 }}
                                className="modern-list-card"
                            >
                                <Row className="fod-row">
                                    {Object.keys(sourceLeads)
                                        .filter(key => sourceLeads[key].total > 0)
                                        .map(key => {
                                            const item = sourceLeads[key];
                                            const meta = sourceMeta[key] || { icon: <FaHistory />, color: "bg-grey" };

                                            return (
                                                <Col span={6} key={key}>
                                                    <div className="stat-card">
                                                        <div className={`stat-icon-wrapper ${meta.color || 'bg-blue'}`}>
                                                            {meta.icon}
                                                        </div>
                                                        <div className="stat-data">
                                                            <div className="stat-label">{key}</div>
                                                            <div className="stat-value">
                                                                <a onClick={() =>
                                                                    this.setState({
                                                                        drawer: true,
                                                                        drawerParam: {
                                                                            title: key,
                                                                            arr: item.arr,
                                                                            count: item.total,
                                                                            bgColorClass: `${meta.color || 'bg-blue'}`,
                                                                            icon: meta.icon
                                                                        }
                                                                    })
                                                                }
                                                                >{item.total}</a>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                            );
                                        })}
                                </Row>
                            </Card>
                        )
                    }

                    {
                        // Conversion By Source
                        Object.keys(sourceConverted)
                            .filter(key => sourceConverted[key].total > 0) // only show if total > 0
                            .length > 0 && (
                            <Card
                                title={
                                    <div className="card-header-flex">
                                        Conversion By Source
                                    </div>
                                }
                                style={{ marginTop: 20 }}
                                className="modern-list-card"
                            >

                                <Row className="fod-row">
                                    {Object.keys(sourceConverted)
                                        .filter(key => sourceConverted[key].total > 0)
                                        .map(key => {
                                            const item = sourceConverted[key];
                                            const meta = sourceMeta[key] || { icon: <FaHistory />, color: "bg-grey" };

                                            return (
                                                <Col span={6} key={key}>
                                                    <div className="stat-card">
                                                        <div className={`stat-icon-wrapper ${meta.color || 'bg-blue'}`}>
                                                            {meta.icon}
                                                        </div>
                                                        <div className="stat-data">
                                                            <div className="stat-label">{key}</div>
                                                            <div className="stat-value">
                                                                <a onClick={() =>
                                                                    this.setState({
                                                                        drawer: true,
                                                                        drawerParam: {
                                                                            title: key,
                                                                            arr: item.arr,
                                                                            count: item.total,
                                                                            bgColorClass: `${meta.color || 'bg-blue'}`,
                                                                            icon: meta.icon
                                                                        }
                                                                    })
                                                                }
                                                                >{item.total}</a>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                            );
                                        })}
                                </Row>
                            </Card>
                        )
                    }


                    {/* Lead Source Insight End */}

                    {/* Counsellor Performance Start */}
                    <div className="section-tag">SC Performance</div>

                    <Row className="fod-row">
                        <Col span={8}>
                            <Card
                                title={
                                    <div className="card-header-flex">
                                        Registrations
                                    </div>
                                }
                                style={{ marginTop: 20 }}
                                className="modern-list-card"
                            >
                                {Object.keys(this.state.newRegistrations).map((key) => {
                                    const item = this.state.newRegistrations[key];

                                    return (
                                        <div className="list-item-row" key={key}>

                                            <span className="label-text" title={key}>{key}</span>
                                            <div
                                                className="count-badge"
                                                onClick={() => this.setState({
                                                    drawer: true,
                                                    drawerParam: {
                                                        title: key + " Counsellings",
                                                        arr: item.arr,
                                                        count: item.total,
                                                        bgColorClass: "bg-blue"
                                                    }
                                                })}
                                            >
                                                {item.total}
                                            </div>
                                        </div>
                                    );
                                })}
                            </Card>

                        </Col >
                        <Col span={8}>
                            <Card
                                title={
                                    <div className="card-header-flex">
                                        Target Vs Registration
                                    </div>
                                }
                                style={{ marginTop: 20 }}
                                className="modern-list-card"
                            >
                                {Object.keys(this.state.targetVsRegistration).map((key) => {
                                    const item = this.state.targetVsRegistration[key];
                                    return (
                                        <div className="list-item-row" key={key}>

                                            <span className="label-text" title={key}>{key}</span>
                                            <div className="count-badge">
                                                {item + "%"}
                                            </div>
                                        </div>
                                    );
                                })}
                            </Card>

                        </Col>
                        {
                            Object.keys(this.state.registeredLeadsData || {}).length > 0 && (
                                <Col span={8}>
                                    <Card
                                        title={
                                            <div className="card-header-flex">
                                                Quality Rating + Registration
                                            </div>
                                        }
                                        style={{ marginTop: 20 }}
                                        className="modern-list-card"
                                    >
                                        {Object.keys(this.state.registeredLeadsData).map((key) => {
                                            const item = this.state.registeredLeadsData[key];

                                            return (
                                                <div className="list-item-row" key={key}>

                                                    <span className="label-text" title={key}>{key}</span>
                                                    <div
                                                        className="count-badge"
                                                        onClick={() => this.setState({
                                                            drawer: true,
                                                            drawerParam: {
                                                                title: key + " Counsellings",
                                                                arr: item.arr,
                                                                count: item.total + "%",
                                                                bgColorClass: "bg-blue"
                                                            }
                                                        })}
                                                    >
                                                        {item.total + "%"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </Card>

                                </Col>
                            )
                        }

                    </Row >

                    {/* Counsellor Performance End */}
                    {/* Alerts Start */}
                    <div className="section-tag">Alerts</div>
                    <Row className="fod-row">
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-blue">
                                    <FaUserCheck />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Untouched Qualified Leads</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Untouched Qualified Leads", arr: untouchedQualified.arr, count: untouchedQualified.total, bgColorClass: "bg-blue", icon: <FaUserCheck /> }
                                        })}>{untouchedQualified.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-red">
                                    <FaFire />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Untouched Hot Leads</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Untouched Hot Leads", arr: untouchedHot.arr, count: untouchedHot.total, bgColorClass: "bg-red", icon: <FaFire /> }
                                        })}>{untouchedHot.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-green">
                                    <FaLightbulb />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Untouched Potential Leads</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Untouched Potential Leads", arr: untouchedPotential.arr, count: untouchedPotential.total, bgColorClass: "bg-green", icon: <FaLightbulb /> }
                                        })}>{untouchedPotential.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-orange">
                                    <FaClipboardList />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Pending Applications</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Pending Applications", arr: pendingApplications.arr, count: pendingApplications.total, bgColorClass: "bg-orange", icon: <FaClipboardList /> }
                                        })}>{pendingApplications.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-cyan">
                                    <FaPassport />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Pending Visa Applications</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Pending Visa Applications", arr: pendingVisaApplications.arr, count: pendingVisaApplications.total, bgColorClass: "bg-cyan", icon: <FaPassport /> }
                                        })}>{pendingVisaApplications.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper bg-purple">
                                    <FaUsers />
                                </div>
                                <div className="stat-data">
                                    <div className="stat-label">Pending Consultancy</div>
                                    <div className="stat-value">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Pending Consultancy", arr: pendingConsultancy.arr, count: pendingConsultancy.total, bgColorClass: "bg-purple", icon: <FaUsers /> }
                                        })}>{pendingConsultancy.total}</a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Alerts End */}

                </div >
            </div >
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (CounsellorDashboard)